import { render, staticRenderFns } from "./ChooseConsolidationOrderPopup.vue?vue&type=template&id=dff61ce6&scoped=true"
import script from "./ChooseConsolidationOrderPopup.vue?vue&type=script&lang=js"
export * from "./ChooseConsolidationOrderPopup.vue?vue&type=script&lang=js"
import style0 from "./ChooseConsolidationOrderPopup.vue?vue&type=style&index=0&id=dff61ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff61ce6",
  null
  
)

export default component.exports